// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.63.2',
  commit: '110cb88fdf6cf4f4438b3603f33f6cedfe70d04e',
  branch: 'platinum',
  dateGenerated: '2026-05-08T16:18:21.730Z',
};